import React from 'react'
import {Link} from "react-router-dom";
function LetsTalk({name, navigate,w,o}) {
    const _width = w ? w : 45
    const [width, setwidth] = React.useState(45)
    if(o){ 
        return  <a href={navigate} target='_blank'className="lets-talk opacity" onMouseEnter={()=>setwidth(_width)} onMouseLeave={()=>setwidth(45)} style={{width}}>
                    <span> {name} </span> 
                    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 512 512'>
                        <polyline points='268 112 412 256 268 400'
                            style={{fill:'none',stroke:'#fff',strokeLinecap:'round',strokeLinejoin:'round',strokeWidth:48}} />
                        <line x1='392' y1='256' x2='100' y2='256'
                            style={{fill:'none',stroke:'#fff',strokeLinecap:'round',strokeLinejoin:'round',strokeWidth:48}} />
                    </svg>
                </a>
    }
    return (
        <Link to={navigate} className="lets-talk opacity" onMouseEnter={()=>setwidth(_width)} onMouseLeave={()=>setwidth(45)} style={{width}}>
            <span> {name} </span> 
            <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 512 512'>
                <polyline points='268 112 412 256 268 400'
                    style={{fill:'none',stroke:'#fff',strokeLinecap:'round',strokeLinejoin:'round',strokeWidth:48}} />
                <line x1='392' y1='256' x2='100' y2='256'
                    style={{fill:'none',stroke:'#fff',strokeLinecap:'round',strokeLinejoin:'round',strokeWidth:48}} />
            </svg>
        </Link>
    )
}

export default LetsTalk
